export const API_ERROR_CODE_MAP = {
  unknown: 'Unknown error occurred',
  hey_syncly__chat__no_feedback: 'No feedback found',
  hey_syncly__studio_item__no_feedback: 'No feedback found',
  notification__not_enough_capacity:
    "Oops! You've hit the maximum limit. You can only create up to five.",
  dashboard__duplicate_key: 'The name already exists',
  search__not_allowed:
    'Maximum date range exceeded for displaying daily value. Adjust your date range.',
  taxonomy__not_enough_capacity: 'Not enough capacity',
  taxonomy__invalid_request: 'Invalid request',
  taxonomy__not_allowed:
    'Operation failed: Classification in subtopic is in progress.',
  taxonomy__duplicate_key: 'The name already exists',
  topic__not_enough_capacity: 'Not enough capacity',
  topic__not_allowed:
    'Operation failed: Classification in subtopic is in progress.',
  product__duplicate_name: 'Same product name already exists',
  scraping_job__exist_in_progress_job:
    'A job is already in progress. This job will be ignored.',
  shared_link__password_empty: 'Password is required to access this link',
  shared_link__password_wrong: 'The password you entered is incorrect',
  shared_link__expired: 'This shared link has expired',
  shared_link__sign_mismatch: 'Invalid shared link signature',
  shared_link__not_exists: 'Shared link not found',
  signal__exists_title: 'A signal with this title already exists',
  notification__exists_title: 'A workflow with this title already exists',
} as const satisfies Record<string, string>;

export type API_ERROR_CODE = keyof typeof API_ERROR_CODE_MAP;

export const getApiErrorMessage = (code: API_ERROR_CODE): string => {
  return API_ERROR_CODE_MAP[code] || 'Unknown error';
};
